import { FileZipOutlined }             from '@ant-design/icons';
import { AppForm }                     from 'components/App/AppForm';
import { withNavigation }              from 'components/App/withNavigation';
import { WithNavigationProps }         from 'components/App/withNavigation';
import dayjs                           from 'dayjs';
import React                           from 'react';
import { Button }                      from 'antd';
import { Col }                         from 'antd';
import { ApiCollection }               from 'collections/ApiCollection';
import Row                             from 'components/App/Row';
import StandDashboardHeader            from 'components/Stand/Dashboard/StandDashboardHeader';
import { MESSAGES_PER_PAGE }           from 'components/Stand/Dashboard/StandDashboardStandMessageListBox';
import { ROLE_STANDIST_DECORATOR }     from 'constants/StandistRoleReference';
import { ROLE_STANDIST_AGENCY }        from 'constants/StandistRoleReference';
import { ROLE_STANDIST_EXHIBITOR }     from 'constants/StandistRoleReference';
import NotificationModel               from 'models/NotificationModel';
import StandDocumentsZipModel          from 'models/StandDocumentsZipModel';
import UserStandRoleModel              from 'models/UserStandRoleModel';
import { privateLayoutStore }          from 'stores/index';
import currentSession                  from 'utils/currentSession';
import { downloadFileFromBlob }        from 'utils/downloadFile';
import handleApiError                  from 'utils/handleApiError';
import { PagedCollection }             from 'collections/PagedCollection';
import FormattedMessageWrapper         from 'components/App/FormattedMessageWrapper';
import PageTitle                       from 'components/App/PageTitle';
import StandDocumentMediaModel         from 'models/StandDocumentMediaModel';
import StandDocumentStatusModel        from 'models/StandDocumentStatusModel';
import { messageErrorIntl }            from 'utils/messageIntl';
import StandDashboardHeaderDropdownBtn from '../../Stand/components/StandDashboardHeaderDropdownBtn';
import SendNotificationForm            from 'forms/SendNotificationForm';
import StandDocumentMessageModel       from 'models/StandDocumentMessageModel';
import StandDocumentMediaStatusModel   from 'models/StandDocumentMediaStatusModel';
import StandDocumentMessageListBox     from './StandDocumentsDashboard/StandDocumentMessageListBox';
import StandDocumentMediaListBox       from './StandDocumentsDashboard/StandDocumentMediaListBox';
import { Collection }                  from '@mathquis/modelx';
import UserModel                       from 'models/UserModel';
import ShowModel                       from 'models/ShowModel';
import StandModel                      from 'models/StandModel';

class StandDocumentsDashboard extends React.Component<WithNavigationProps> {

  public agencyVirtualCollection: Collection<UserModel>;
  public decoratorVirtualCollection: Collection<UserModel>;
  public exhibitorVirtualCollection: Collection<UserModel>;

  public show = new ShowModel();
  public stand = new StandModel();
  public standDocumentMediaCollection = new ApiCollection(StandDocumentMediaModel);
  public standDocumentMediaStatusCollection = new ApiCollection(StandDocumentMediaStatusModel);
  public standDocumentMessagePagedCollection = new PagedCollection(StandDocumentMessageModel);
  public standDocumentStatusCollection = new ApiCollection(StandDocumentStatusModel);
  public standistCollection = new ApiCollection(UserModel);

  public state = {
    dataLoading: true,
  };

  public userStandRoleCollection = new ApiCollection(UserStandRoleModel);

  constructor(props: any) {
    super(props);

    this.standDocumentMessagePagedCollection.itemsPerPage = MESSAGES_PER_PAGE;

    this.exhibitorVirtualCollection = this.standistCollection.createVirtualCollection(
      (user: UserModel) =>
        !!this.userStandRoleCollection.find(
          (userStandRole: UserStandRoleModel) =>
            userStandRole.userIri === user.iri &&
            userStandRole.standistRole === ROLE_STANDIST_EXHIBITOR,
        ),
    );

    this.agencyVirtualCollection = this.standistCollection.createVirtualCollection(
      (user: UserModel) =>
        !!this.userStandRoleCollection.find(
          (userStandRole: UserStandRoleModel) =>
            userStandRole.userIri === user.iri &&
            userStandRole.standistRole === ROLE_STANDIST_AGENCY,
        ),
    );

    this.decoratorVirtualCollection = this.standistCollection.createVirtualCollection(
      (user: UserModel) =>
        !!this.userStandRoleCollection.find(
          (userStandRole: UserStandRoleModel) =>
            userStandRole.userIri === user.iri &&
            userStandRole.standistRole === ROLE_STANDIST_DECORATOR,
        ),
    );
  }

  public async componentDidMount() {
    await this.fetchData();

    try {
      await privateLayoutStore.setCurrentShowId(this.show.id);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    this.standDocumentStatusCollection.list();
    this.standDocumentMediaStatusCollection.list();
  }

  public async componentDidUpdate(prevProps: WithNavigationProps) {
    if (prevProps.params !== this.props.params) {
      await this.fetchData();

      try {
        await privateLayoutStore.setCurrentShowId(this.show.id);
      } catch (error: any) {
        if (error.name === 'show_not_found') {
          this.props.navigate('/404');
        }

        if (error.name === 'get_show_unauthorized') {
          this.props.navigate('/erreur');
        }
      }
    }
  }

  public render() {
    const externalSync = this.show.get('externalSync', false);

    return (
      <>
        <div className="page-loading">
          {this.state.dataLoading && (
            <Button htmlType="button" loading>
              <FormattedMessageWrapper id="Chargement" />
            </Button>
          )}
        </div>

        <PageTitle title={<FormattedMessageWrapper id="Tableau de bord des documents" />} />

        <Row>
          <Col span={24}>
            <StandDashboardHeader
              agencyVirtualCollection={this.agencyVirtualCollection}
              decoratorVirtualCollection={this.decoratorVirtualCollection}
              dropdownBtn={
                <StandDashboardHeaderDropdownBtn
                  additionalItems={[
                    {
                      icon: <FileZipOutlined />,
                      key: 'DOWNLOAD_ZIP',
                      label: <FormattedMessageWrapper id="Télécharger tous les documents" />,
                      onClick: () => this.downloadStandsSecurityAttestation(),
                    },
                  ]}
                  agencyCollection={this.agencyVirtualCollection}
                  decoratorCollection={this.decoratorVirtualCollection}
                  exhibitorCollection={this.exhibitorVirtualCollection}
                  externalSync={externalSync}
                  fetchStandistsWithRoles={this.fetchRoleCollectionAndStandistsData}
                  setConfirmationNotifyVisible={value => {
                    if (value) {
                      const externalSync = this.show.get('externalSync', false);
                      AppForm.open(SendNotificationForm, {
                        externalSync: !!externalSync,
                        model: new NotificationModel(),
                        selectedRows: [this.stand],
                        standCollectionFull: new ApiCollection(StandModel),
                      }, {
                        okText: <FormattedMessageWrapper id="Envoyer" />,
                        title: <FormattedMessageWrapper id="Confirmer l'envoi d'une notification" />,
                      });
                    }
                  }}
                  stand={this.stand}
                  userStandRoleCollection={this.userStandRoleCollection}
                />
              }
              exhibitorVirtualCollection={this.exhibitorVirtualCollection}
              externalSync={externalSync}
              fetchStandistsWithRoles={this.fetchRoleCollectionAndStandistsData}
              stand={this.stand}
              standDocumentStatusCollection={this.standDocumentStatusCollection}
              userStandRoleCollection={this.userStandRoleCollection}
            />
          </Col>

          <Col span={14}>
            <StandDocumentMessageListBox
              fetchParentData={this.fetchData}
              show={this.show}
              stand={this.stand}
              standDocumentMediaCollection={this.standDocumentMediaCollection}
              standDocumentMessagePagedCollection={this.standDocumentMessagePagedCollection}
            />
          </Col>

          <Col span={10}>
            <StandDocumentMediaListBox
              fetchParentData={() => {
                this.stand.fetch();
                this.fetchStandDocuments();
              }}
              setDataLoading={(loading: boolean) => this.setState({ loading, })}
              show={this.show}
              stand={this.stand}
              standDocumentMediaCollection={this.standDocumentMediaCollection}
              standDocumentMediaStatusCollection={this.standDocumentMediaStatusCollection}
            />
          </Col>
        </Row>
      </>
    );
  }

  private downloadStandsSecurityAttestation = () => {
    this.setState({ dataLoading: true });

    const standDocumentsZipModel = new StandDocumentsZipModel();

    const standsIds = [this.stand.id];

    standDocumentsZipModel
      .fetch({
        params: {
          ids: standsIds,
        },
      })
      .then(
        (response: any) => {
          const time = dayjs().format('YYYY-MM-DD_HHmm');
          let fileName = [this.show.showName, this.stand.name, 'Documents', time].join(' - ');
          fileName += '.zip';
          const blob = new Blob([response.data], { type: 'application/zip' });
          downloadFileFromBlob(blob, fileName);
        },
        error => {
          if (error.connectorError.response.status === 400) {
            messageErrorIntl("Aucun document.");
          } else {
            handleApiError(error);
          }
        },
      )
      .finally(() => {
        this.setState({ dataLoading: false });
      });
  };

  private fetchData = async () => {
    this.setState({ dataLoading: true });

    const { id } = this.props.params;

    try {
      await this.stand.set('id', id).fetch();
    } catch (error: any) {
      const requestStatus = error?.connectorError?.request?.status || error?.connectorError?.response?.status;

      if (requestStatus === 401) {
        // logout already done by the connector
        this.props.navigate('/logout');
      } else if (requestStatus === 404 || requestStatus === 405) {
        this.props.navigate('/404');
      } else {
        this.props.navigate('/erreur');
      }

      return;
    }

    currentSession.showId = this.stand.showId;

    try {
      await privateLayoutStore.setCurrentShowId(this.stand.showId);
    } catch (error: any) {
      if (error.name === 'show_not_found') {
        this.props.navigate('/404');
      }

      if (error.name === 'get_show_unauthorized') {
        this.props.navigate('/erreur');
      }

      return;
    }

    await Promise.all([
      this.show.set({ id: this.stand.showId }).fetch(),

      this.fetchStandDocuments(),

      this.fetchRoleCollectionAndStandistsData(),
    ]);

    // await for dataLoading
    await this.standSeenDocuments();

    this.setState({ dataLoading: false });
  };

  private fetchRoleCollectionAndStandistsData = async () => {
    const { id } = this.props.params;

    await this.userStandRoleCollection.setFilter('stand', id).list();

    const usersIris = this.userStandRoleCollection.getUniques('user');
    await this.standistCollection.setFilter('id', usersIris).list();
  };

  private fetchStandDocuments = async () => {
    await Promise.all([
      this.standDocumentMessagePagedCollection
        .setFilter('stand', this.stand.id)
        .setSorts({
          createdAt: false,
          id: false,
        })
        .list(),

      this.standDocumentMediaCollection.setFilter('stand', this.stand.id).list(),
    ]);
  };

  private standSeenDocuments = async () => {
    if (currentSession.isAdminOrSupport && this.stand?.unSeenDocuments) {
      await this.stand.patch({ unSeenDocuments: false });
    }
  };
}

const WrappedStandDocumentsDashboard = withNavigation(StandDocumentsDashboard);

export default WrappedStandDocumentsDashboard;
